module.exports = __webpack_public_path__ + "img/voice.00778239.jpg";